export const baseImageUrl = 'https://d3agh3dpu1smgs.cloudfront.net/main'
export const cloudfrontBaseUrl = 'https://d3agh3dpu1smgs.cloudfront.net'

export const cssDomains = ['mypoundsaver', 'wisecompare']
